export const DATA = {
  "Skill level": "Beginner",
  "Time to complete": "Approx. 60 hours",
  Certificate: "Included",
  Prerequesties: "None",
  description: "Build Coding Skills from Basics to Applications",
  about:
    "Master the fundamentals of Python programming through hands-on coding. This course covers core and advanced concepts, data structures, and real-world applications—equipping you to write clean, efficient code for software development and automation tasks.",
  skills: ["Logical Thinking", "Project Development", "Debugging Techniques"],
  reviews: {
    1: {
      name: "Rowan Delgado",
      review:
        "This IoT course was incredibly informative! I learned how sensors, microcontrollers, and cloud platforms communicate. The practical demos made everything easy to understand.",
    },
    2: {
      name: "Keira Morrison",
      review:
        "A perfect introduction to IoT. The instructor explained the architecture in a simple and engaging way. I finally understand how IoT systems work end-to-end.",
    },
    3: {
      name: "Zaid Hussain",
      review:
        "Loved the hands-on projects! Setting up devices and connecting them to cloud dashboards was the highlight of the course. Very beginner-friendly.",
    },
    4: {
      name: "Martha Quinn",
      review:
        "The course gave me a clear understanding of sensors, communication protocols, and embedded programming. Great content for IoT enthusiasts.",
    },
    5: {
      name: "Nikolai Petrov",
      review:
        "A fantastic course that covers both theory and implementation. I especially enjoyed learning about MQTT, Wi-Fi modules, and data logging.",
    },
    6: {
      name: "Ariana Vazquez",
      review:
        "The real-time examples and device simulations made the learning process exciting. I feel confident working with IoT systems thanks to this course.",
    },
    7: {
      name: "Callum Hayes",
      review:
        "I appreciated how the instructor broke down complex concepts like communication protocols and cloud integration. Very easy to follow.",
    },
    8: {
      name: "Irina Balan",
      review:
        "A well-structured course that introduces IoT fundamentals clearly. The hands-on IoT dashboard activities were extremely helpful.",
    },
    9: {
      name: "Reese Gallagher",
      review:
        "This course explained microcontrollers, sensors, and data transmission in such a simple way. Perfect for beginners who like practical learning.",
    },
    10: {
      name: "Siddarth Chopra",
      review:
        "I enjoyed how we built real IoT prototypes. Learning about different sensors and connecting them to the cloud was eye-opening.",
    },
    11: {
      name: "Helena Murphy",
      review:
        "Great teaching style and well-paced modules. I liked how the course covered everything from hardware basics to cloud analytics.",
    },
    12: {
      name: "Eamon Wright",
      review:
        "This course gave me clear insights into IoT architecture. Understanding how devices send and receive data was extremely valuable.",
    },
    13: {
      name: "Fatou Kouyate",
      review:
        "The explanations were thorough but simple. I enjoyed learning about embedded systems and how they interact with networks.",
    },
    14: {
      name: "Jonah Peters",
      review:
        "Amazing course for beginners! The projects helped me understand how IoT is applied in smart homes, healthcare, and automation.",
    },
    15: {
      name: "Safia Ibrahim",
      review:
        "I learned more than I expected. The sections on connectivity and IoT protocols were especially useful for someone new to the field.",
    },
    16: {
      name: "Lucian Vogel",
      review:
        "The course covered the fundamentals very effectively. I enjoyed setting up simple IoT systems and seeing them work in real-time.",
    },
    17: {
      name: "Anika Shah",
      review:
        "Clear explanations and great hands-on examples. Understanding sensor data and cloud integration was a big win for me.",
    },
    18: {
      name: "Giovanni Russo",
      review:
        "A highly practical course. I loved working with sensors and writing small programs for microcontrollers. Very engaging!",
    },
    19: {
      name: "Kyra Bennett",
      review:
        "One of the best IoT introductions I’ve taken. The examples were realistic and helped me understand industry applications easily.",
    },
    20: {
      name: "Mateo Fuentes",
      review:
        "The course helped me understand how IoT ecosystems work. The hands-on modules were the best part—very fun and educational.",
    },
    21: {
      name: "Amina Yusuf",
      review:
        "Everything was explained with clarity. I especially liked learning about network communication and device-to-cloud workflows.",
    },
    22: {
      name: "Lincoln Sharp",
      review:
        "Great content and smooth delivery. The instructor made topics like IoT protocols and message brokering simple to grasp.",
    },
    23: {
      name: "Vera Novak",
      review:
        "This course was simple yet comprehensive. I enjoyed experimenting with basic IoT circuits and cloud dashboards.",
    },
    24: {
      name: "Denzel Hawkins",
      review:
        "Very hands-on and practical. Learning how sensors send data and how cloud dashboards visualize it was incredibly satisfying.",
    },
    25: {
      name: "Freya Lindberg",
      review:
        "A wonderful introduction to IoT systems. Everything from device setup to real-time monitoring was explained beautifully.",
    },
  },
  modules: {
    "Introducon to IoT & Embedded Systems": [],
    "Raspberry Pi Setup & Environment. Installing OS & essential  libraries. GPIO basics and interfacing":
      [],
    "Sensor Data Acquisition & Processing": [],
    "Device Communication Protocols MQTT, HTTP, and REST APIs": [],
    "Data Visuazation & Dashboarding": [],
    "IoT Automaon & Control": [],
    "Integraon wh AI/ML Models": [],
    "Capstone Project: Smart home, smart agriculture, or  industal monitoring application":
      [],
  },
};
